import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";

const ROLES = {
  gestion_general: "Gestión General",
  recepcion: "Recepción",
  medico: "Médico",
  administracion: "Administración",
  superadmin: "Super Admin"
};

export default function Header({ titulo, backLabel, backRuta }) {
  const { currentUser, userRole, clinicaId, clinicaData } = useAuth();
  const { theme, isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut(auth);
    navigate("/");
  }

  return (
    <div style={{
      background: theme.bgHeader,
      borderBottom: `0.5px solid ${theme.borderHeader}`,
      padding: "0 24px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      height: "60px", flexShrink: 0
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <img src="/Isotipo-Deluxe.png" alt="Deluxe" style={{ height: "36px", width: "auto" }} />
        {backRuta && (
          <>
            <button onClick={() => navigate(backRuta)} style={{
              background: "none", border: "none", color: "rgba(255,255,255,0.7)",
              cursor: "pointer", fontSize: "13px", fontFamily: "'Montserrat', sans-serif"
            }}>← {backLabel || "Volver"}</button>
            <div style={{ width: "1px", height: "16px", background: theme.border }} />
          </>
        )}
        <span style={{ color: "#FFFFFF", fontWeight: "600", fontSize: "15px", fontFamily: "'Montserrat', sans-serif" }}>
          {titulo}
        </span>
      </div>
      <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
        <button
          onClick={toggleTheme}
          title={isDark ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
          style={{
            background: "none", border: `0.5px solid ${theme.borderInput}`,
            borderRadius: "8px", padding: "5px 10px", cursor: "pointer",
            fontSize: "16px", lineHeight: 1
          }}
        >
          {isDark ? "☀️" : "🌙"}
        </button>
        {currentUser && (
          <div style={{ textAlign: "right" }}>
            <div style={{ color: "#FFFFFF", fontSize: "12px" }}>{currentUser?.email}</div>
            <div style={{ color: theme.accent, fontSize: "10px", letterSpacing: "0.5px" }}>
              {clinicaData?.nombre && `${clinicaData.nombre} · `}{ROLES[userRole] || userRole}
            </div>
          </div>
        )}
        <button onClick={handleLogout} style={{
          background: "none", border: `0.5px solid ${theme.borderInput}`,
          borderRadius: "8px", padding: "5px 12px",
          color: "#FFFFFF", fontSize: "11px", cursor: "pointer",
          fontFamily: "'Montserrat', sans-serif"
        }}>
          Salir
        </button>
      </div>
    </div>
  );
}